import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const equipmentSizesAdapter = getAdapter({ idFieldName: 'value' });

const equipmentSizesSlice = createSlice({
  name: 'equipmentSizes',
  initialState: equipmentSizesAdapter.getInitialState(),
  reducers: {
    setEquipmentSizes: (state, { payload: { equipmentSizes } }) => {
      equipmentSizesAdapter.setAll(state, equipmentSizes);
    },
  },
});

const selectors = equipmentSizesAdapter.getSelectors(({ equipmentSizes }) => equipmentSizes);

export const getEquipmentSizesIncludingDeleted = (state) => selectors.selectAll(state);

export const getEquipmentSizes = (state) => getEquipmentSizesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setEquipmentSizes,
} = equipmentSizesSlice.actions;

export default equipmentSizesSlice.reducer;
